import { z } from 'zod';

export const releasePosSchema = z.object({
  description: z.string().min(1, { message: 'Campo obrigatório' }),
})

export type ReleasePosValidationSchema = z.infer<typeof releasePosSchema>